import SmsDashboard from "../../pages/Dashboards/SmsDashboard";
import RCSDashboard from "../../pages/Dashboards/RCSDashboard";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";
const routesConfig = [
  {
    path: "/dashboard/sms",
    component: SmsDashboard,
    roles: [1],
  },
  {
    path: "/dashboard/rcs",
    component: RCSDashboard,
    roles: [1],
  },
];

const Overview = createProtectedRoutes(routesConfig);

export default Overview;
